import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Search as SearchIcon, X } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { useDebounce } from 'rooks';

const Search = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get('q') || '';
  });
  const [searchInput, setSearchInput] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get('q') || '';
  });
  const setSearchQueryDebounced = useDebounce(setSearchQuery, 400);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (searchQuery) {
      params.set('q', searchQuery);
    } else {
      params.delete('q');
    }
    navigate({ search: params.toString() });
  }, [searchQuery, location.search, navigate]);

  const clearSearch = () => {
    setSearchQuery('');
    setSearchInput('');
  };

  return (
    <div className="flex gap-4 max-w-lg mb-4">
      <div className="relative flex-1">
        <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder="Search Coaches"
          className="pl-10"
          autoFocus
          onChange={(e) => {
            setSearchInput(e.target.value);
            setSearchQueryDebounced(e.target.value);
          }}
          value={searchInput}
        />
        {searchInput.length > 2 && (
          <X
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4 cursor-pointer"
            onClick={clearSearch}
          />
        )}
      </div>
    </div>
  );
};

export default Search;
